import EtiquetteBaseDialog from '../../etiquette/AlertDialog/BaseDialog'
import styled from 'styled-components';

const BaseDialog = styled(EtiquetteBaseDialog)`
  
`;
export default BaseDialog;